<template>
    <cadastro-simples-form
        endpoint="raca"
        rota-base="/admin/raca"
        titulo-singular="Raça/Cor"
        :campos-extras='[{"campo":"cod_censo","label":"Código INEP","tipo":"int","descricao":"Código do INEP/Educacenso (0=Não declarada, 1=Branca, 2=Preta, 3=Parda, 4=Amarela, 5=Indígena)"}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
